export function getBaseUrl(): string {
  const base = window.__STATICS_BASE_URL__;
  return base.startsWith('http') ? base : `${location.protocol}${base}`;
}
